import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TooltipItem,
} from 'chart.js';
import { SessionDurationData } from '@models/statistics';
import moment from 'moment';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

interface SessionDurationChartProps {
  data: SessionDurationData[];
}

const SessionDurationChart: React.FC<SessionDurationChartProps> = ({ data }) => {
  const chartData = {
    labels: data.map((item) => moment(item.date).format('MM/DD')),
    datasets: [
      {
        label: '체류시간 중간값(분)',
        data: data.map((item) => item.medianDuration / 60),
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        tension: 0.1,
      },
      {
        label: '체류시간 평균값(분)',
        data: data.map((item) => item.trimmedMeanDuration / 60),
        borderColor: 'rgb(255, 205, 86)',
        backgroundColor: 'rgba(255, 205, 86, 0.2)',
        tension: 0.1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: '일별 세션 체류시간',
      },
      tooltip: {
        callbacks: {
          afterLabel: (context: TooltipItem<'line'>) => {
            const dataIndex = context.dataIndex;
            const sessionCount = data[dataIndex]?.sessionCount;
            return `세션 수: ${sessionCount}개`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: '체류시간 (분)',
        },
      },
      x: {
        title: {
          display: true,
          text: '날짜',
        },
      },
    },
  };

  return <Line data={chartData} options={options} />;
};

export default SessionDurationChart;
